import { z } from 'zod'
import { useZodForm, validateEmissionDate } from '@minetrace/ui/forms'

export const step4bLegalDocumentSchema = z.object({
  documentType: z.number().min(1, 'Tipo de documento es requerido'),
  presentationDate: z.string().min(1, 'Fecha de emisión es requerida'),
  // Caducidad es opcional — algunos tipos de documento (e.g. EIAd) no caducan.
  expirationDate: z.string().optional(),
  fileNumber: z.string().min(1, 'N° Expediente es requerido'),
  documentStatus: z.number().min(1, 'Estado documento es requerido'),
}).superRefine((data, ctx) => {
  validateEmissionDate(data.presentationDate, 'presentationDate', ctx)
})

export type Step4bLegalDocumentFormValues = z.infer<typeof step4bLegalDocumentSchema>

const defaultValues: Step4bLegalDocumentFormValues = {
  documentType: 0,
  presentationDate: '',
  expirationDate: '',
  fileNumber: '',
  documentStatus: 0,
}

export const useStep4bLegalDocumentsForm = (props?: { defaultValues?: Step4bLegalDocumentFormValues; disabled?: boolean }) => {
  return useZodForm<Step4bLegalDocumentFormValues>({
    validationSchema: step4bLegalDocumentSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
